var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4286 17.6922C22.0203 17.6922 22.5 18.1959 22.5 18.8172V22.1939C22.5 23.023 21.8562 23.6922 21.0713 23.6922H8.92872C8.14044 23.6922 7.5 23.0185 7.5 22.1939V18.8172C7.5 18.1959 7.9797 17.6922 8.57143 17.6922C9.16316 17.6922 9.64286 18.1959 9.64286 18.8172V21.0661C9.64286 21.278 9.80246 21.4422 9.99934 21.4422H20.0007C20.1974 21.4422 20.3571 21.2738 20.3571 21.0661V18.8172C20.3571 18.1959 20.8368 17.6922 21.4286 17.6922ZM14.9998 6C15.6181 6 16.1216 6.49775 16.1216 7.11175V13.9512C16.1216 14.3608 16.3593 14.4599 16.6524 14.1677L17.9397 12.2925C18.9972 11.2419 20.5838 12.8182 19.5263 13.8688L15.8051 17.6661C15.37 18.1101 14.668 18.1108 14.2335 17.6713L10.4737 13.8688C9.41625 12.8182 11.0025 11.2419 12.0603 12.2925L13.3474 14.1677C13.6404 14.4599 13.878 14.363 13.878 13.9512V7.11175C13.878 6.5011 14.3803 6 14.9998 6Z",
    fill: "#455A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.fd33d69ced12b037f1922920f5cb5c4a.svg";
export { ForwardRef as ReactComponent };